<script setup lang="ts">
const {
  links = [
    {
      title: "rates",
      to: "/",
    },
    {
      title: "hotel info",
      to: "https://www.citizenm.com/",
    },
  ],
  paperBackground = false,
  centered = false,
  justified = false,
} = defineProps<{
  // NOTE: we're not going to type the links here, as this component will not be used after release of new navigation
  links: { title: string; to: string }[];
  paperBackground?: boolean;
  centered?: boolean;
  justified?: boolean;
}>();

const menuClasses = computed(() => ({
  paper: paperBackground,
  centered,
  justified,
}));
</script>

<template>
  <div v-if="links.length" class="menu-wrap" :class="menuClasses">
    <nav role="navigation" data-testid="navigation">
      <NuxtLink
        v-for="(link, index) in links"
        class="link"
        v-bind:key="index"
        :to="link.to"
        :href="link.to"
        data-testid="navigation-menu-item"
      >
        {{ $t(link.title) }}
      </NuxtLink>
      <slot name="additionalLink"></slot>
    </nav>
  </div>
</template>

<script lang="ts">
// Note: this will not be addressed, as we're not going to use this component after the new navigation is released
export default {
  name: "MenuBase",
};
</script>

<style scoped lang="scss">
/* stylelint-disable no-descending-specificity */

/* TODO: fix all the specificity issues */
.menu-wrap {
  width: 100% !important;
  margin: 0 0 var(--space-20);

  &.paper {
    nav {
      padding: 0 var(--space-24) 0;
      box-shadow: var(--shadow);
    }
  }

  &.centered {
    nav {
      justify-content: center;
    }
  }

  &.justified {
    nav {
      justify-content: space-between;
      width: 100%;
      text-align: center;
    }
  }

  @include mdx {
    width: calc(100% + var(--page-padding-mobile));
    max-width: calc(100svw - var(--page-padding-mobile, 1.5rem));
    margin-right: calc(-1 * var(--page-padding-mobile));

    nav {
      overflow: auto;
    }
  }
}

nav {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
}

.link {
  display: block;
  margin: 0;
  padding: 13px 0;
  color: var(--color-inactive-black);
  font-size: var(--font-size-btn);
  font-family: var(--font-family-bold);
  line-height: var(--line-height);
  text-decoration: none;
  border-bottom: 2px solid transparent;
  transition: var(--transition-all);

  &:hover,
  &:focus,
  &:active {
    color: var(--primary-black);
    outline: none;
  }

  &:disabled {
    color: var(--color-black-disabled-surface);
  }

  + .link {
    margin: 0 0 0 var(--space-24);
  }

  &.router-link-active {
    color: var(--primary-black);
    border-bottom: 2px solid var(--primary-red);
  }

  @include mdx {
    white-space: nowrap;
  }
}
</style>
